import { namespace } from '../../../../../../FrontendBundle/Resources/js/ofcs';
import Interface from '../../../../../../FrontendBundle/Resources/js/ofcs/interface';

/**
 * The item view represents the drawable item on the canvas.
 *
 * This is the interface definition of the item view classes.
 */
const ViewInterface = new Interface({
    /**
     * Show image of item.
     */
    showImage() {},

    /**
     * Hide image of item.
     */
    hideImage() {},

    /**
     * Trigger an event.
     */
    trigger() {},

    /**
     * Listen on an event.
     */
    on() {},

    /**
     * Remove event listener.
     */
    off() {},
});

namespace('Ofcs.Editor.Canvas.ItemView');
Ofcs.Editor.Canvas.ItemView.ViewInterface = ViewInterface;
export default ViewInterface;
